module.exports = __webpack_public_path__ + "static/img/0012-A-01.02cf32c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audioimg/0012-A-01.jpg
// module id = mwRk
// module chunks = 0